<template>
  <div class="socialhub-settings-wrapper">
    <div class="socialhub-settings-container">
      <div class="topics-container">
        <div class="topics-title">
          <p>{{ $t("components.socialhub.socialHubSettings.subjects") }}</p>
          <div class="topics-actions">
            <el-button size="mini" type="primary" icn="fas fa-plus" @click="newTopic" :loading="loading == 'newTopic'" round>{{ $t("components.socialhub.socialHubSettings.addSubject") }}</el-button>
          </div>
        </div>
        <draggable :list="socialHub.topics" class="topics-list" tag="div" handle=".el-icon-s-grid" v-bind="dragOptions" @start="dragList = true" @end="changeSort">
          <div class="topics-list-item " :class="{ 'topic-disabled': !item.isActive }" v-for="(item, index) in socialHub.topics" :key="index + '-topic-item'">
            <div class="drag-icon">
              <i class="el-icon-s-grid burger"></i>
            </div>
            <div class="topic-title">
              <el-input :placeholder="$t('components.socialhub.socialHubSettings.enterTopicTitle')" :class="$inputError('socialHub.Topics[' + index + '].Title', validationErrors)" @input="inputTopic" v-model="item.title" @change="updateSocialHub"></el-input>
            </div>
            <el-dropdown trigger="click" :hide-on-click="false" :show-timeout="250" class="topic-actions">
              <span class="el-dropdown-link">
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="topic-action-dw-item">
                  <span class="action-title">{{ $t("components.socialhub.socialHubSettings.color") }}</span>
                  <el-color-picker v-model="item.color" @change="changeSettings"></el-color-picker>
                </el-dropdown-item>
                <el-dropdown-item class="topic-action-dw-item">
                  <span class="action-title">{{ $t("components.socialhub.socialHubSettings.show") }}</span>
                  <el-switch v-model="item.isActive" @change="changeSettings"></el-switch>
                </el-dropdown-item>
                <el-dropdown-item class="topic-action-dw-item">
                  <span class="action-title">{{ $t("components.socialhub.socialHubSettings.deleteTopic") }}</span>
                  <el-popconfirm :title="$t('components.socialhub.socialHubSettings.deleteSure')" @confirm="deleteTopic(index)">
                    <el-button type="danger" size="mini" slot="reference" icon="fas fa-trash" circle></el-button>
                  </el-popconfirm>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </draggable>
      </div>

      <div class="settings-container">
        <div class="hub-settings-title">
          <p>{{ $t("components.socialhub.socialHubSettings.socialHubSettings") }}</p>
        </div>
        <div class="settings-list">
          <div class="settings-list-item" @click="changeApprovalType(0)" :class="{ active: socialHub.postApprovalType == 0 }">
            <div class="settings-title">
              <i class="fa fa-check-circle accept"></i>
              <span>{{ $t("components.socialhub.socialHubSettings.autoPublish") }}</span>
            </div>
            <div class="settings-actions">
              <i class="fa mr-2" :class="loading == 'approvalType' ? 'fa fa-spinner fa-spin' : 'fa-check'"></i>
            </div>
          </div>

          <div class="settings-list-item" @click="changeApprovalType(1)" :class="{ active: socialHub.postApprovalType == 1 }">
            <div class="settings-title">
              <i class="fa fa-clock waiting"></i>
              <span>{{ $t("components.socialhub.socialHubSettings.autoApproval") }}</span>
            </div>
            <div class="settings-actions">
              <i class="fa mr-2" :class="loading == 'approvalType' ? 'fa fa-spinner fa-spin' : 'fa-check'"></i>
            </div>
          </div>

          <div class="settings-list-item" @click="changeApprovalType(2)" :class="{ active: socialHub.postApprovalType == 2 }">
            <div class="settings-title">
              <i class="fa fa-times-circle reject"></i>
              <span>{{ $t("components.socialhub.socialHubSettings.closeNew") }}</span>
            </div>
            <div class="settings-actions">
              <i class="fa mr-2" :class="loading == 'approvalType' ? 'fa fa-spinner fa-spin' : 'fa-check'"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="otheractions-container">
        <div class="otheractions-title">
          <p>{{ $t("components.socialhub.socialHubSettings.otherTransactions") }}</p>
        </div>
        <div class="otheractions-item">
          <div class="otheractions-exclaim">
            <i class="fa fa-exclamation-circle"></i>
            <p v-html="$t('components.socialhub.socialHubSettings.clearSocialHub')"></p>
          </div>

          <el-select v-model="clearList" @clear="clearList = null" :class="$inputError('type', validationErrors2)" :placeholder="$t('components.socialhub.socialHubSettings.placeholderSelect')" clearable>
            <el-option v-for="item in getEnums.find(x => x.title == 'ClearSocialHubType').enums" :key="item.key + '-post-type'" :label="item.displayName" :value="item.key"></el-option>
          </el-select>

          <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" class="delete-button" @confirm="clearSocialHub">
            <el-button type="danger" :loading="loading == 'clearListSocial'" slot="reference" round>{{ $t("components.socialhub.socialHubSettings.deleteSelected") }}</el-button>
          </el-popconfirm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "SocialHubSettings",
  components: {
    draggable
  },
  data() {
    return {
      clearList: null,
      loading: false,
      timeout: null,
      color: "#03658C",
      value1: true,
      validationErrors: [],
      validationErrors2: []
    };
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    socialHub() {
      return this.$store.state.event.event.socialHub;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    async changeSort() {
      await this.$store.dispatch("updateSocialHubSettings", { ...this.socialHub });
    },
    async inputTopic() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.changeSettings();
      }, 500);
    },
    clearSocialHub() {
      this.loading = "clearListSocial";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("socialHubClear", this.clearList);
        this.validationErrors2 = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.clearList = null;
        }
        this.loading = false;
      }, 500);
    },
    changeApprovalType(type) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "approvalType";
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("updateSocialHubSettings", { ...this.socialHub, postApprovalType: type });
        this.loading = false;
      }, 500);
    },
    async changeSettings() {
      await this.$store.dispatch("updateSocialHubSettings", this.socialHub);
    },
    async newTopic() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "newTopic";
      this.timeout = setTimeout(async () => {
        var payload = {
          id: null,
          title: "New Topic",
          isActive: false,
          color: this.$store.state.event.event.color ? this.$store.state.event.event.color : "#03658c"
        };
        this.socialHub.topics.push(payload);
        await this.$store.dispatch("updateSocialHubSettings", this.socialHub);
        this.loading = false;
      }, 500);
    },
    async deleteTopic(index) {
      this.socialHub.topics.splice(index, 1);
      await this.updateSocialHub();
    },
    async updateSocialHub() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("updateSocialHubSettings", this.socialHub);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less">
.socialhub-settings-wrapper {
  height: 100%;
  width: 100%;
  padding: 0px 0px;
  position: relative;
  overflow: hidden;

  .socialhub-settings-container {
    height: 100%;
    max-height: calc(~"100vh - 38px");
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0px 8px;
    padding-bottom: 100px;

    .topics-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin: 16px 0px;

      .topics-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin: 16px 0px;

        p {
          font-size: 16px;
          color: #292f3b;
          font-weight: 600;
          margin: 0;
          padding: 0;
        }
      }
      .topics-list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        .topics-list-item {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          background: #f1f1f1;
          border-radius: 8px;
          padding: 10px 8px;
          margin-bottom: 8px;

          &.topic-disabled {
            background-color: #fff2f2 !important;
          }

          &:last-child {
            margin-bottom: 0px !important;
          }

          .drag-icon {
            cursor: grab;
            margin-right: 6px;

            i {
              box-sizing: border-box;
              font-size: 20px;
              color: #505763;
            }
          }

          .topic-title {
            width: 100%;
          }
          .topic-actions {
            display: flex;
            align-items: center;
            margin-left: 12px;
            color: #8c929c;
            font-size: 12px;
            padding: 6px 0px;
            cursor: pointer;
          }
        }
      }
    }

    .settings-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin: 16px 0px;

      .hub-settings-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin: 16px 0px;

        p {
          font-size: 16px;
          color: #292f3b;
          font-weight: 600;
          margin: 0;
          padding: 0;
        }
      }

      .settings-list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;

        .settings-list-item {
          .settings-actions {
            i {
              transition: all 0.5s ease-in-out;
              display: none;
            }
          }

          &.active {
            .settings-actions {
              i {
                transition: all 0.5s ease-in-out;
                display: inline-block;
              }
            }
          }
          cursor: pointer;
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          background: #f1f1f1;
          border-radius: 8px;
          padding: 10px 8px;
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0px !important;
          }

          .settings-title {
            width: 100%;

            i {
              font-size: 26px;
              margin-right: 6px;

              &.accept {
                color: #00d4c8;
              }

              &.reject {
                color: #ff6565;
              }

              &.waiting {
                color: #f69656;
              }
            }
            span {
              color: #292f3b;
              font-weight: 500;
              font-size: 14px;
            }
          }
          .settings-actions {
            display: flex;
            align-items: center;
            margin-left: 6px;

            button {
              margin-left: 8px;
            }
          }
        }
      }
    }

    .otheractions-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin: 16px 0px;

      .otheractions-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin: 16px 0px;

        p {
          font-size: 16px;
          color: #292f3b;
          font-weight: 600;
          margin: 0;
          padding: 0;
        }
      }

      .otheractions-item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        background: #fff2f2;
        border-radius: 8px;
        padding: 16px 14px;

        .otheractions-exclaim {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          i {
            color: #ff6565;
            font-size: 40px;
            margin-right: 12px;
          }

          p {
            font-size: 15px;
            color: #292f3b;
            font-weight: 600;
            margin: 0;
            padding: 0;
            span {
              font-size: 13px;
              display: block;
              font-weight: 400;
              color: #505763;
              line-height: 1.3;
            }
          }
        }

        .el-select {
          margin-bottom: 18px;
          width: 100%;
        }

        .delete-button {
          width: 100%;
          button {
            width: 100%;
          }
        }
      }
    }
  }
}

.topic-action-dw-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: unset;
  .el-color-picker {
    width: 40px;
  }

  &:hover {
    background-color: white !important;
  }

  .action-title {
    margin-right: 16px;
  }

  span {
    span {
      button {
        i {
          margin-right: unset;
        }
      }
    }
  }
}
.fa-spin {
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/SocialHubSettings.vue